import React from "react"
import autobind from "class-autobind"
import { InfoWindow, GoogleMapLoader, GoogleMap, Marker } from "react-google-maps"
import { triggerEvent } from "react-google-maps/lib/utils"
import * as utils from "../../helpers/utils"
import { ILocationDocument, IRecord } from "../../models"
import * as timeHelper from "../../helpers/timeHelper"
import moment from "moment"
interface IMarker {
    position: {
        lat: number
        lng: number
    },
    location?: ILocationDocument
    showInfoWindow: boolean
    key: string
    icon: string
    punchInfo?: string
    locationName?: string
}
interface IProps {
    record: IRecord
}
interface IState {
    markers: IMarker[]
    centerPosition: { lat: number, lng: number }
}

export default class NearLocationsPunchMap extends React.Component<IProps, IState>  {
    private _googleMapComponent
    constructor(props: IProps) {
        super(props)
        this.state = {
            markers: [],
            centerPosition: { lat: 41.075264, lng: -97.545192 }
        }
        autobind(this)
    }

    componentDidMount() {
        setTimeout(() => {
            this.props.record && this.setMapData(this.props.record)
        }, 0)
        window.addEventListener("resize", this.handleWindowResize)
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleWindowResize, false)
    }

    componentWillReceiveProps(nextProps) {
        nextProps.record && this.setMapData(nextProps.record)
    }

    setMapData(record: IRecord) {
        let markers = []

        const locationLat = utils.getNumberFromBigNumber(record.LocationLatitude)
        const locationLng = utils.getNumberFromBigNumber(record.LocationLongitude)

        const locationMarker: IMarker = {
            position: {
                lat: locationLat,
                lng: locationLng
            },
            showInfoWindow: false,
            key: "location",
            icon: "/assets/markers/location-pin.png",
            locationName: record.LocationExternalId ? `${record.LocationName} - ${record.LocationExternalId}` : record.LocationName
        }

        const punchLat = utils.getNumberFromBigNumber(record.Punch.MetaData.Latitude)
        const punchLng = utils.getNumberFromBigNumber(record.Punch.MetaData.Longitude)
        const punchMarker: IMarker = {
            position: {
                lat: punchLat,
                lng: punchLng
            },
            showInfoWindow: false,
            key: "punch",
            icon: "/assets/markers/punch-pin.png",
            punchInfo: `${record.UserFirstName} ${record.UserLastName} - ${moment(timeHelper.keepConvertUTCToLocal(record.Punch.DateTimeLocal)).format("YYYY-MM-DD HH:mm")}`
        }

        const nearLoationMarkers = record.NearLocations.map((i, index) => {
            return {
                position: {
                    lat: utils.getNumberFromBigNumber(i.Location.Address.Latitude),
                    lng: utils.getNumberFromBigNumber(i.Location.Address.Longitude)
                },
                location: i.Location,
                showInfoWindow: false,
                key: `near_location_${index}`,
                icon: "/assets/markers/near_location-pin.png",
                locationName: i.ExternalId ? `${i.Name} - ${i.ExternalId}` : i.Name
            }
        })

        if (locationLat !== 0 || locationLng !== 0) {
            markers.push(locationMarker)
        }

        markers.push(punchMarker)
        markers = markers.concat(nearLoationMarkers)

        const bounds = new google.maps.LatLngBounds()

        if (locationLat !== 0 || locationLng !== 0) {
            bounds.extend(new google.maps.LatLng(locationLat, locationLng))
        }
        bounds.extend(new google.maps.LatLng(punchLat, punchLng))

        this.setState({ markers: markers })
        triggerEvent(this._googleMapComponent, "resize")
        this._googleMapComponent.fitBounds(bounds)
    }

    handleWindowResize() {
        triggerEvent(this._googleMapComponent, "resize")
    }

    handleMarkerClick(index) {
        this.state.markers[index].showInfoWindow = true
        this.setState({ markers: this.state.markers })
    }

    handleMarkerClose(index) {
        this.state.markers[index].showInfoWindow = false
        this.setState({ markers: this.state.markers })
    }

    renderInfoWindow(marker: IMarker, index) {
        return (
            <InfoWindow onCloseclick={() => this.handleMarkerClose(index)}>
                <div>
                    <div style={{ fontWeight: "bold", marginBottom: 10 }}>{marker.locationName ? marker.locationName : marker.punchInfo && marker.punchInfo}</div>
                    <div>{marker.location && marker.location.Address.StreetName}</div>
                    <div>
                        {marker.position.lat}, {marker.position.lng}
                    </div>
                </div>
            </InfoWindow>
        )
    }

    render() {
        return (
            <GoogleMapLoader
                containerElement={
                    <div style={{ height: "100%", width: "100%" }} />
                }
                googleMapElement={
                    <GoogleMap ref={(map) => (this._googleMapComponent = map)} defaultZoom={13} defaultCenter={this.state.centerPosition}>
                        {this.state.markers.map((marker, index) => {
                            return (
                                <Marker key={index} {...marker} onClick={() => this.handleMarkerClick(index)}>
                                    {marker.showInfoWindow ? this.renderInfoWindow(marker, index) : null}
                                </Marker>
                            )
                        })}
                    </GoogleMap>
                }
            />
        )
    }
}
